export default function clearLocalStorage() {
    localStorage.removeItem('resetAll');
    localStorage.removeItem('postType');
    localStorage.removeItem('searchInput');
    localStorage.removeItem('activeFilters');
    localStorage.removeItem('activeCases');
};
